"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransactions = void 0;
const constructEtherscanURL_1 = require("./constructEtherscanURL");
const fetchJSON_1 = require("./fetchJSON");
const fetchTransactions = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, fetchJSON_1.fetchJSON)((0, constructEtherscanURL_1.constructEtherscanURL)(options));
    if (response.status === "0" && response.message === "No transactions found") {
        return [];
    }
    if (response.status !== "1") {
        throw new Error(`Failed to calculate emissions: ${response.message}`);
    }
    return response.result;
});
exports.fetchTransactions = fetchTransactions;
